export default "__VITE_ASSET__1f2a251f__"